import React from "react";
import { Box, Typography, CardContent, Divider, Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { formatCurrency } from "../../../utils/currencyUtils";
import { LedgerEntryStatsDto } from "../../../shared/dtos/ledgerEntry/LedgerEntryStatsDto";

interface LedgerEntryWidgetProps {
  data: LedgerEntryStatsDto;
}

const LedgerEntryWidget: React.FC<LedgerEntryWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("LEDGER_ENTRY");
  const Icon = meta.icon;

  const isBalanced = data.totalDebitVolumeToday === data.totalCreditVolumeToday;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {meta.title}
            </Typography>
            {isBalanced && (
              <Chip
                icon={<CheckCircleIcon />}
                label="Balanced"
                color="success"
                size="small"
                variant="outlined"
                sx={{ mt: 0.5 }}
              />
            )}
          </Box>
        </Box>

        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Total Entries
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {data.totalEntriesToday}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }}>Volume Today</Divider>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            textAlign: "center",
          }}
        >
          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Debit
            </Typography>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "info.main" }}
            >
              {formatCurrency(data.totalDebitVolumeToday)}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Credit
            </Typography>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "secondary.main" }}
            >
              {formatCurrency(data.totalCreditVolumeToday)}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default LedgerEntryWidget;
